import { createTheme } from "@mui/material/styles";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { PaletteFromHex } from "../../helpers/palette.js";
import { GlobalStyles } from "../../lib/mui-imports.js";
import { setStructure, setVariables } from "../../store/builder";
import DeepBuild from "./DeepBuild.jsx";
import Edit from "./Edit.jsx";
import useBootstrapStyles from "./styles/bootstrap-styles.js";
import useElementStyles from "./styles/element-styles.js";
// import Tools from "./Tools.jsx";

export default function BuildContent(props) {
    const dispatch = useDispatch();

    const variables = useSelector(state => state.builder.variables);
    const structure = useSelector(state => state.builder.structure);

    React.useEffect(() => {
        if (variables === props.variables && structure === props.structure) {
            return;
        }

        dispatch(setVariables(props.variables));
        dispatch(setStructure(props.structure));
    }, [props.variables, props.structure]);

    const palette = {
        primary: PaletteFromHex(variables?.color?.userPrimary ?? variables?.color?.primary),
        secondary: PaletteFromHex(variables?.color?.userSecondary ?? variables?.color?.secondary),
    };

    const elementsUsed = [];
    (function recursion(elements) {
        for (const element of elements) {
            !elementsUsed.includes(element.name) && elementsUsed.push(element.name);
            element.children && recursion(element.children);
        }
    })(structure);

    const eStyles = props.variables.eStyles;
    const theme = createTheme({});
    const MobileBreakpoint = theme.breakpoints.down("sm");

    const BSclasses = useBootstrapStyles();
    const { classes: ESclasses, globalStyles } = useElementStyles(elementsUsed, {
        eStyles,
        palette,
        theme,
        MobileBreakpoint,
    });
    const CNBuildContent = ["build-content", BSclasses["build-content"], ESclasses["elements"]];

    let _DeepBuild = DeepBuild(structure, variables);
    props.edit && (_DeepBuild = <Edit {...{ ...props.edit, structure }}>{_DeepBuild}</Edit>);
    // props.tools && (_DeepBuild = <Tools>{_DeepBuild}</Tools>);

    return (
        <>
            <GlobalStyles styles={{ ...globalStyles }} />
            <div className={CNBuildContent.join(" ")}>{_DeepBuild}</div>
        </>
    );
}
